var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("active.title")) + " ")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("active.sub_title")) + " ")]), _c('form', {
    staticClass: "form"
  }, _vm._l(_vm.verifyFields, function (field, index) {
    return _c('div', {
      key: index
    }, [field.type === 'text' && field.matched_key ? _c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.matched_key],
        expression: "form[field.matched_key]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form[field.matched_key].$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field),
        "required": field.required
      },
      domProps: {
        "value": _vm.form[field.matched_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.matched_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.matched_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 送出 ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }